import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import react from 'react';
import axios from 'axios';
import {host} from '../../function/api'
const initialState = {
    user: '',
    token: '',
    status: false,
    loading: false,
    redirectFlag: false,
    message: '',
    success: false,
    error: null,
    errorName: '',
    errorMobile: '',
    errorPassword: '',
    mobileError: '',
    passwordError: ''
}
// const config = {
//       headers: { 'X-CSRFToken': csrftoken },
// }
export const agentSignin = createAsyncThunk (
    'agent/signin',
    async(data, thunkAPI) => {
        try{
            const response = await axios({
                method: 'POST',
                url: `${host}agent/login`, 
                data: data,
                headers: { 
                    'Content-Type': 'application/json',
                    // 'X-CSRF-TOKEN': token.content,
                    'X-Requested-With': 'XMLHttpRequest',
                }  
            });
            
            return response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const exhibitionSignin = createAsyncThunk (
    'agent/signin',
    async(data, thunkAPI) => {
        try{
            const response = await axios({
                method: 'POST',
                url: `${host}exhibition/login`, 
                data: data,
                headers: { 
                    'Content-Type': 'application/json',
                    // 'X-CSRF-TOKEN': token.content,
                    'X-Requested-With': 'XMLHttpRequest',
                }  
            });
            
            return response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)
export const signIn = createAsyncThunk (
    'login/user',
    async(account, thunkAPI) => {
        try{
            const response = await axios.post(`${host}login`, 
            account,
            {
                headers: { 
                    'Content-Type': 'application/json',
                    // 'X-CSRF-TOKEN': token.content,
                    'X-Requested-With': 'XMLHttpRequest',
                }  
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const signUp = createAsyncThunk(
    'register/user', 
    async(account, thunkAPI) => {
        try{
            const response = await axios.post(`${host}register`,
             account,
            {
                headers: { 
                    'Content-Type': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`                 
                }
            });
            return await response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error)
        }
});

const authenticationSlice = createSlice({
    
    name: 'authentication',
    initialState,
    reducers: {

    },
    extraReducers: {
        // login agent state
        [agentSignin.fulfilled]: (state, {payload}) => {
            // state.user = payload
            state.loading = false  
            // console.log(payload.error)
            state.mobileError = ''
            state.passwordError = ''
            if(payload.data && payload.token && payload.status == true){
                localStorage.setItem('user', JSON.stringify(payload.data))
                localStorage.setItem('token', payload.token)
                state.user = payload.data 
                state.token = payload.token 
                state.redirectFlag = true
            }
        },
        [agentSignin.pending]: (state) => {
            state.loading = true
            state.message = 'Pelease wait ...'
            state.error = 'waiting ...'
        },
        [agentSignin.rejected]: (state,{payload}) => {
            state.loading = false
            if(payload.response.data.error){
                state.mobileError = payload.response.data.error.mobile 
                state.passwordError = payload.response.data.error.password 
            }else if(payload.response.data.message) {
                state.passwordError = payload.response.data.message
            }
        },


        // login exhibition state
        [exhibitionSignin.fulfilled]: (state, {payload}) => {
            // state.user = payload
            state.loading = false  
            // console.log(payload.error)
            state.mobileError = ''
            state.passwordError = ''
            if(payload.data && payload.token && payload.status == true){
                localStorage.setItem('user', JSON.stringify(payload.data))
                localStorage.setItem('token', payload.token)
                state.user = payload.data 
                state.token = payload.token 
                state.redirectFlag = true
            }
        },
        [exhibitionSignin.pending]: (state) => {
            state.loading = true
            state.message = 'Pelease wait ...'
            state.error = 'waiting ...'
        },
        [exhibitionSignin.rejected]: (state,{payload}) => {
            state.loading = false
            if(payload.response.data.error){
                state.mobileError = payload.response.data.error.mobile 
                state.passwordError = payload.response.data.error.password 
            }else if(payload.response.data.message) {
                state.passwordError = payload.response.data.message
            }
        },

        // login user state
        [signIn.fulfilled]: (state, {payload}) => {
            // state.user = payload
            state.loading = false  
            // console.log(payload.error)
            state.mobileError = ''
            state.passwordError = ''
            if(payload.data && payload.token && payload.status == true){
                localStorage.setItem('user', JSON.stringify(payload.data))
                localStorage.setItem('token', payload.token)
                state.user = payload.data 
                state.token = payload.token 
                state.redirectFlag = true
            }
        },
        [signIn.pending]: (state) => {
            state.loading = true
            state.message = ''
            state.error = ''
        },
        [signIn.rejected]: (state,{payload}) => {
            state.loading = false
            if(payload.response.data.error){
                state.mobileError = payload.response.data.error.mobile 
                state.passwordError = payload.response.data.error.password 
            }else if(payload.response.data.message) {
                state.passwordError = payload.response.data.message
            }
        },
        // register user state
        [signUp.fulfilled]: (state, action) => {
            state.loading = false
            state.success = true
            state.status = true
            state.message = action.payload.message
        },
        [signUp.pending]: (state) => {
            state.loading = true
            state.success = false
            state.status = false
        },
        [signUp.rejected]: (state,{payload}) => {
            state.loading = false
            state.success = false
            state.status = true
            state.errorName = ''
            state.errorMobile = ''
            state.errorPassword = ''
            if(payload.response.data.error){
                state.errorName = payload.response.data.error.name 
                state.errorMobile = payload.response.data.error.mobile 
                state.errorPassword = payload.response.data.error.password 
            }
        }
    }
})

export const {
    
} = authenticationSlice.actions

export default authenticationSlice.reducer;